import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const VisaIcon = (props: IconProps) => (
  <ChakraIcon
    width={12}
    height={8}
    viewBox="0 0 48 31"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    {...props}
  >
    <mask
      id="mask0_4051_566"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="10"
      width="32"
      height="11"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.4071 10.0005H8V20.1435H39.4071V10.0005Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_4051_566)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.1316 10.6877L20.033 20.498H17.4949L19.5944 10.6877H22.1316ZM32.809 17.0218L34.1451 13.3381L34.9141 17.0218H32.809ZM35.6409 20.498H37.988L35.9392 10.6877H33.7731C33.2858 10.6877 32.8751 10.9708 32.6927 11.4072L28.8848 20.498H31.549L32.0786 19.0325H35.3341L35.6409 20.498ZM29.0167 17.2947C29.0281 14.706 25.4366 14.5629 25.4613 13.4062C25.4693 13.0545 25.8042 12.6805 26.5378 12.5845C26.9008 12.5373 27.9037 12.5005 29.0397 13.0233L29.4858 10.9433C28.8747 10.7215 28.0892 10.5083 27.1114 10.5083C24.6032 10.5083 22.8374 11.8419 22.8231 13.7511C22.8064 15.164 24.0832 15.9513 25.0453 16.4211C26.0336 16.9018 26.3652 17.2102 26.3614 17.6402C26.3541 18.2987 25.5729 18.589 24.8423 18.6004C23.5666 18.6202 22.8259 18.2555 22.2358 17.9806L21.7764 20.1304C22.3687 20.4024 23.4635 20.6397 24.5985 20.6514C27.2648 20.6514 29.0084 19.3349 29.0167 17.2947ZM18.5053 10.6877L14.3935 20.498H11.7111L9.68748 12.6687C9.56461 12.1867 9.45803 12.0098 9.08464 11.8071C8.47452 11.4757 7.46717 11.1651 6.58093 10.9723L6.64069 10.6877H10.9593C11.5094 10.6877 12.0046 11.0537 12.1297 11.6878L13.1984 17.3648L15.8396 10.6877H18.5053Z"
        fill="#B1B4B9"
      />
    </g>
    <rect
      opacity="0.3"
      x="0.5"
      y="0.5"
      width="47"
      height="30"
      rx="3.5"
      stroke="#999999"
    />
  </ChakraIcon>
);
